import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import tr from './tr.json';
import en from './en.json';
import ru from './ru.json';
import kk from './kk.json';
import az from './az.json';

const savedLanguage = localStorage.getItem('flexbee_lang') || 'tr';

i18n.use(initReactI18next).init({
  resources: {
    tr: { translation: tr },
    en: { translation: en },
    ru: { translation: ru },
    kk: { translation: kk },
    az: { translation: az },
  },
  lng: savedLanguage,
  fallbackLng: 'tr',
  interpolation: {
    escapeValue: false,
  },
});

// index.html hardcodes <html lang="en">. CSS casing (text-transform:uppercase,
// e.g. sidebar category headers) follows the element's lang, not i18n's
// in-memory language — without this, Turkish "i" uppercases as "I" instead of
// "İ" whenever the active language is tr. Sync on load and on every change.
document.documentElement.lang = savedLanguage;

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('flexbee_lang', lng);
  document.documentElement.lang = lng;
});

export default i18n;
